<template>
  <div class="search-input-middle__wrapper">
    <div class="search-input-middle">
      <input
        class="search-input-middle__value"
        type="text"
        v-model="localValue"
      />
      <div class="search-input-middle__placeholder" v-if="!localValue">
        <v-icon color="#181b23" size="22">$search</v-icon>
        <span>{{ placeholder }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: String,
    placeholder: {
      default: "Search",
      type: String,
    },
  },
  data() {
    return {
      localValue: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.localValue = value;
      },
    },
    localValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped lang="scss">
.search-input-middle {
  height: 46px;
  position: relative;
  padding: 0 20px;
  border: 1px solid #e5e5e5;
  border-radius: 100px;
  width: 600px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    color: #181b23;

    span {
      margin-left: 5px;
    }
  }

  &__value {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    padding: 0 45px;
    outline: none !important;
    text-align: center;
  }
  &__value:focus + &__placeholder {
    opacity: 0.6;
  }
}
</style>
